import React, { Component, lazy } from 'react';
import Markdown from 'markdown-to-jsx';

import { componentLoader } from '../../../../utils/src';

import SuccessGreenTickIcon from '../../icons/SuccessGreenTickIcon';

import { NxtwaveWhiteLogo } from '../MarkDownComponents';

import Image from '../Image';

const ImageSlick = lazy(() =>
  componentLoader(
    () => import(/* webpackChunkName: "ImageSlick" */ '../ImageSlickComponent')
  )
);

interface CustomMarkdownInterface {
  content: string;
}

class CustomMarkdown extends Component<CustomMarkdownInterface> {
  override render() {
    const { content } = this.props;
    return (
      <Markdown
        options={{
          overrides: {
            ImageSlick: {
              component: ImageSlick
            },
            NxtwaveWhiteLogo: {
              component: NxtwaveWhiteLogo
            },
            GreenTickIcon: {
              component: SuccessGreenTickIcon
            },
            Image : {
              component: Image
            }
          }
        }}
      >
        {content}
      </Markdown>
    );
  }
}
export default CustomMarkdown;
